var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"main-container"},_vm._l((_vm.valuesAsList),function(value){return _c('div',{key:value.county},[_c('div',{staticClass:"county-label",style:({
        width: _vm.labelWidth + 'px'
      })},[_vm._v(" "+_vm._s(value.county)+" ")]),_c('div',{staticClass:"county-value",style:({
        width: _vm.valueWidth + 'px',
        'margin-left': _vm.gutterWidth + 'px'
      })},[_vm._v(" "+_vm._s(_vm.getValueLabel(value.value))+" ")]),_c('div',{staticClass:"value-bar",style:({
        width: _vm.getWidth(value.value) + 'px',
        'margin-left': _vm.gutterWidth + 'px',
        'background-color': _vm.getColor(value.value)
      })})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }